import { cn } from '@library/component-utils/cn';
import { useMemo } from 'react';

// format to not have udnerscore in the type
export type BadgeType =
  | 'canceled'
  | 'contest_lost'
  | 'contest_win'
  | 'lost'
  | 'no_op'
  | 'partial_win'
  | 'pending'
  | 'pushed'
  | 'refunded'
  | 'voided_mi'
  | 'won';

export const badgeClasses = (type: BadgeType) => {
  switch (type) {
    case 'contest_lost':
    case 'lost':
      return 'border-status-failure bg-status-failure/10 text-status-failure';
    case 'contest_win':
    case 'partial_win':
    case 'won':
      return 'border-status-success bg-status-success/10 text-status-success';
    case 'pending':
      return 'border-status-warning bg-status-warning/10 text-status-warning';
    case 'pushed':
    case 'canceled':
    case 'no_op':
    case 'voided_mi':
      return 'border-status-neutral bg-status-neutral/10 text-status-neutral';
    case 'refunded':
      return 'border-status-info bg-status-info/10 text-status-info';
    default:
      return '';
  }
};

export interface BadgeProps {
  type: BadgeType;
}

export const Badge = ({ type }: BadgeProps) => {
  const badgeClass = useMemo(() => badgeClasses(type), [type]);

  // format to not have udnerscore in the type
  const formattedType = type.replace(/_/g, ' ');

  return (
    <span
      className={cn(
        'flex h-7 w-fit items-center rounded border px-2 font-semibold uppercase leading-none',
        badgeClass
      )}
    >
      {formattedType}
    </span>
  );
};
